module.exports = __webpack_public_path__ + "static/img/car4.b5f937c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car4.png
// module id = QXk9
// module chunks = 1